import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { AsyncEntity } from 'src/global';
import { RootState } from 'src/store';
import { firmwareGroupSelectors } from './firmwareGroups.state';
import { FirmwareGroup } from './firmwareGroups.types';

export const useFirmwareGroupsState = (): RootState['firmwareGroups'] => {
  const firmwaresGroups = useSelector<RootState, RootState['firmwareGroups']>(state => state.firmwareGroups);

  useDebugValue(firmwaresGroups);

  return firmwaresGroups;
};

export const useFirmwareGroupsValues = (): FirmwareGroup[] => {
  const firmwaresGroups = useSelector<RootState, RootState['firmwareGroups']>(state => state.firmwareGroups);

  const result = firmwareGroupSelectors.selectAll(firmwaresGroups);

  useDebugValue(result);

  return result;
};

export const useFirmwareGroupById = (id: number): AsyncEntity<FirmwareGroup> | null => {
  const firmwaresGroups = useSelector<RootState, RootState['firmwareGroups']>(state => state.firmwareGroups);

  const result = firmwareGroupSelectors.selectById(firmwaresGroups, id) || null;

  useDebugValue(result);

  return result;
};
